import React from "react";
import "../../Assessts/Styles/Galarry.scss";

import IOText from "../../ReUableComponents/ImageOntext";
import PBanner from "../../Assessts/Images/Gallary/Patnerships/PatnershipBanner.png";

import { Row, Col } from "react-bootstrap";

import MOU1 from "../../Assessts/Images/Gallary/Patnerships/MOU1.png";
import MOU2 from "../../Assessts/Images/Gallary/Patnerships/MOU2.png";
import MOU3 from "../../Assessts/Images/Gallary/Patnerships/MOU3.png";

import SO1 from "../../Assessts/Images/Gallary/Patnerships/SO/SO1.png";
import SO2 from "../../Assessts/Images/Gallary/Patnerships/SO/SO2.png";
import SO3 from "../../Assessts/Images/Gallary/Patnerships/SO/SO3.png";
import SO4 from "../../Assessts/Images/Gallary/Patnerships/SO/SO4.png";
import SO5 from "../../Assessts/Images/Gallary/Patnerships/SO/SO5.png";
import SO6 from "../../Assessts/Images/Gallary/Patnerships/SO/SO6.png";

const Partnerships = () => {

    const MOU = [
        { img: MOU1 },
        { img: MOU2 },
        { img: MOU3 },
    ];

    const SOPeople = [
        { img: SO1 },
        { img: SO2 },
        { img: SO3 },
        { img: SO4 },
        { img: SO5 },
        { img: SO6 },
    ];

    const SEdata = [
        { Data: MOU, Tittle: "MoU signing", SubTittle: "MoU signing with Osmania University to strengthen scholarship implementation." },
        { Data: SOPeople, Tittle: "Scholarship Outreach", SubTittle: "Scholarship outreach sessions conducted at colleges and universities." },
    ];

    return (
        <>
            <div className="Single_Banner mt-2 mb-4">
                <IOText Image={PBanner} Alt="EMpower" Text={<div className="Text-MainDiv w-100" >
                    <div ><span style={{ color: "#F7D670" }}>Educational and Health-Related Initiatives</span> Implemented to
                        <span style={{ color: "#F7D670" }}>Support Student</span> Well-Being and Continuity.</div>

                </div>} />
            </div>
            <div className="SEngagement">
                {SEdata.map((item) => (
                    <>
                        <div className="Web-MainHeading"> {item.Tittle}  </div>
                        <div className="Web-SubHeading"> {item.SubTittle}  </div>
                        <div className="container-fluid  mb-3 p-2">
                            <Row className="dflex  ">
                                {item.Data.map((item) => (
                                    <Col className="dflex  flexd-column alignitems mt-3" >
                                        <img src={item.img} alt="{`${item}`}" />
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </>
                ))}
            </div>
        </>
    );
};
export default Partnerships;